import * as yup from 'yup';

export const resetPasswordSchema = yup.object().shape({
  newPassword: yup
    .string()
    .trim()
    .required('New password is required.')
    .min(8, 'Password must be at least 8 characters.')
    .max(20, 'Password cannot exceed 20 characters.')
    .matches(/[a-z]/, 'Must contain at least one lowercase letter.')
    .matches(/[A-Z]/, 'Must contain at least one uppercase letter.')
    .matches(/[0-9]/, 'Must contain at least one number.')
    .matches(/[!@#$%^&*]/, 'Must contain at least one special character.'),
  confirmPassword: yup
    .string()
    .required('Please confirm your password.')
    .oneOf([yup.ref('newPassword')], 'Passwords must match.'),
});

export const suspendUserSchema = yup.object().shape({
  reason: yup.object().nullable().required('Please select a reason for suspension.'),
  details: yup.string().trim().nullable().required('Details are required.'),
});
